module.exports = __webpack_public_path__ + "static/media/3.2961699a.svg";